// @flow
import React from "react";

import roundToLowest100 from "@justpark/helpers/src/roundToLowest100/roundToLowest100";
import styles from "./ratingWithBookingCount.module.scss";
import MinimalReviewStars from "../MinimalReviewStars";
import Typography from "../Typography";
import SparkleIcon from "../qicons/SparkleIcon";

type Props = {
  rating: number,
  bookingCount: number
};

const RatingWithBookingCount = ({ rating, bookingCount }: Props) => {
  const roundedCount = roundToLowest100(bookingCount);
  const isRounded = roundedCount !== bookingCount;

  const countStr = `${roundedCount}${isRounded ? "+" : ""}`;

  if (rating === 0) {
    return (
      <div className={styles.base} data-cy="just-added">
        <SparkleIcon size="1x" />
        <Typography color="muted" size="secondary">
          <div className={styles.text}>Just added</div>
        </Typography>
      </div>
    );
  }

  return (
    <div className={styles.base}>
      <MinimalReviewStars rating={rating} />
      {roundedCount > 0 ? (
        <Typography color="muted" size="secondary">
          <div className={styles.text}>
            {countStr} {roundedCount === 1 ? "Booking" : "Bookings"}
          </div>
        </Typography>
      ) : null}
    </div>
  );
};

export default RatingWithBookingCount;
